export const en = {
    // App branding
    'app.name': 'Cram & Toss',
    'app.nameEn': '考完即弃',
    'app.tagline': 'Generated for one exam. Then tossed.',
    // Common
    'common.settings': 'Settings',
    'common.close': 'Close',
    'common.unknownError': 'unknown error',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.save': 'Save',
    'common.next': 'Next',
    'common.previous': 'Back',
    'common.back': 'Back',
    'common.continue': 'Continue',
    'common.finish': 'Finish',
    'common.delete': 'Delete',
    'common.loading': 'Loading…',
    'common.error': 'Something went wrong',
    'common.retry': 'Retry',
    // Settings
    'settings.title': 'Settings',
    'settings.language': 'Interface Language',
    'settings.languageHint': 'Takes effect immediately; preference saved locally.',
    'settings.theme': 'Theme',
    'settings.themeLight': 'Light',
    'settings.themeDark': 'Dark',
    'settings.themeAuto': 'System',
    // Nav
    'nav.dashboard': 'Dashboard',
    'nav.flashcards': 'Flashcards',
    'nav.quiz': 'MCQ',
    'nav.drill': 'Drill',
    'drill.title': 'Drill',
    'drill.subtitle': 'Pick a kind, scope it down, start practicing.',
    'drill.kindLabel': 'Kind',
    'drill.scopeLabel': 'Scope',
    'drill.scopeAll': 'All chapters',
    'drill.start': 'Start →',
    'drill.empty': 'No drillable items yet for this course',
    'drill.emptyHint': 'Generate or import content first — drillable kinds will appear here.',
    'nav.mindmap': 'Mind Map',
    'nav.glossary': 'Glossary',
    'nav.lectureNotes': 'Lecture notes',
    'nav.essay': 'Essay Drill',
    'nav.wrongAnswers': 'Wrong Answers',
    'nav.mockExam': 'Mock Exam',
    'nav.mockCenter': 'Mock Center',
    'nav.guide': 'Guide',
    'guide.backHome': 'Back to home',
    'guide.linkText': 'User guide',
    'nav.proofDrill': 'Proof Drill',
    'nav.freeResponse': 'Free Response',
    'nav.readingPassage': 'Reading',
    'nav.bookmarks': 'Bookmarks',
    'nav.examModeGroup': 'Exam mode',
    'nav.manageGroup': 'Manage',
    'nav.settings': 'Course settings',
    'nav.outline': 'Outline',
    'outline.title': 'Curriculum Outline',
    'outline.empty': 'No outline data',
    'outline.emptyHint': 'The outline is generated during ingest. It will appear here after the first generation.',
    'outline.chapter': 'Chapter',
    'outline.concepts': 'concepts',
    'outline.topics': 'topics',
    'outline.items': 'items',
    'outline.noOutline': 'Outline not yet generated',
    'outline.noOutlineHint': 'Generate content first — the curriculum outline will appear here.',
    'outline.confirmedHint': 'Your confirmed outline — all generated content follows this structure.',
    'outline.source': 'Source',
    'outline.sourceUser': 'User provided',
    'outline.sourceLLM': 'LLM generated',
    'outline.regenRunning': 'Generating content…',
    'nav.history': 'History',
    'history.title': 'Generation History',
    'history.empty': 'No generation history',
    'history.emptyHint': 'Ingest results will appear here after your first content generation.',
    'history.loadingDetail': 'Loading generation history…',
    'history.course': 'Course',
    'history.generatedAt': 'Generated',
    'history.items': 'items',
    'history.tokens': 'tokens',
    'history.duration': 'duration',
    'history.quality': 'Quality',
    'history.errors': 'errors',
    'history.warns': 'warns',
    'history.noResults': 'No results yet',
    'history.noResultsHint': 'Generate content for a course to see it here.',
    'history.viewCourse': 'View course',
    'history.gapReport': 'Gap report',
    'onboard.welcome': 'Welcome to ExamForge',
    'onboard.welcomeSub': 'Your study companion for exam preparation',
    'onboard.step1Title': 'Create a course',
    'onboard.step1Text': 'Enter your course title, upload source PDFs, and configure what you want to generate.',
    'onboard.step2Title': 'Generate content',
    'onboard.step2Text': 'AI reads your materials and produces MCQs, flashcards, essays, and more — all traceable to source.',
    'onboard.step3Title': 'Study with focus',
    'onboard.step3Text': 'Drill by topic, track weak areas with spaced repetition, and take mock exams under time pressure.',
    'onboard.step4Title': 'Refine & iterate',
    'onboard.step4Text': 'Review the curriculum outline, check audit reports, and generate content for individual chapters as needed.',
    'onboard.next': 'Next',
    'onboard.skip': 'Skip',
    'onboard.done': 'Got it',
    'onboard.start': 'Create your first course',
    'nav.regen': 'Content Generation',
    'refine.mode': 'Mode',
    'refine.modeReplace': 'Replace — overwrite existing items',
    'refine.modeAdd': 'Add — append new items',
    'refine.addCount': 'Items to add',
    'refine.hint': 'Custom hint',
    'refine.hintPlaceholder': 'e.g. "focus on chapter 3 frameworks"',
    'refine.running': 'Generating… {stage} ({done} stages done)',
    'refine.done': 'Generation complete — {tokens} tokens, {duration}',
    'refine.failed': 'Generation failed: {error}',
    'refine.noSources': 'No source files',
    'refine.noSourcesHint': 'Upload source files first to enable content generation.',
    'diff.title': 'Changes',
    'diff.before': 'Before',
    'diff.after': 'After',
    'diff.noChange': 'No changes detected',
    'diff.close': 'Close',
    'diff.field': 'Field',
    'diff.added': 'Added',
    'diff.removed': 'Removed',
    'courseSettings.heading': 'Course settings',
    'courseSettings.subtitle': 'Edit config · generate content · clear · import/export · delete',
    'courseSettings.basicsHeading': 'Basics',
    'courseSettings.contentHeading': 'Content ops',
    'courseSettings.contentHint': 'Import accepts a course-config file (NOT generated quiz content). Replaces config; your progress is kept.',
    'courseSettings.dangerHeading': 'Danger zone',
    'courseSettings.dangerHint': 'Clear progress only resets wrong-answers/SRS/quiz history. Delete removes everything (config + content + progress + uploaded PDFs).',
    'courseSettings.regenerate': 'Generate content',
    // TECH_DEBT §14: LLM API registration pending (code ref kept in comment, not UI)
    'courseSettings.regenerateDisabledTooltip': 'Content generation will be available soon',
    'courseSettings.exportConfig': 'Export config',
    'courseSettings.importConfig': 'Import config',
    'courseSettings.importConfirm': 'Replace current course config? Progress will be kept.',
    'courseSettings.importOk': '✓ Config imported, refreshing…',
    'courseSettings.importFailed': 'Import failed',
    'courseSettings.exportOk': '✓ Config downloaded',
    'courseSettings.clearProgress': 'Clear progress',
    'courseSettings.clearProgressConfirm': 'Clear wrong-answers, SRS state, quiz history? This cannot be undone.',
    'courseSettings.clearProgressOk': '✓ Progress cleared, refreshing…',
    'courseSettings.deleteCourse': 'Delete entire course',
    'courseSettings.deleteCourseConfirm1': 'Delete this course? Includes config, content, progress, uploaded PDFs.',
    'courseSettings.deleteCourseConfirm2': 'Confirm again — this is irreversible. Continue?',
    'courseSettings.saveOk': '✓ Saved',
    'courseSettings.saveFailed': 'Save failed',
    // Course creation form
    'form.createCourse': 'New Course',
    'form.step1.title': 'Basics',
    'form.step1.heading': 'What course is this?',
    'form.step1.courseTitle': 'Course title',
    'form.step1.courseTitlePlaceholder': 'e.g. International Business / Probability / Brand Management',
    'form.step1.discipline': 'Specialization',
    'form.step1.disciplineHumanities': 'Humanities',
    'form.step1.disciplineLanguages': 'Languages',
    'form.step1.disciplineArts': 'Arts & Design',
    'form.step1.disciplineBusiness': 'Business',
    'form.step1.disciplineEconomics': 'Economics',
    'form.step1.disciplineLaw': 'Law',
    'form.step1.disciplineSocial': 'Psych & Social',
    'form.step1.disciplineMathematics': 'Mathematics',
    'form.step1.disciplinePhysics': 'Physics',
    'form.step1.disciplineChemistry': 'Chemistry',
    'form.step1.disciplineBiology': 'Bio & Medicine',
    'form.step1.disciplineCS': 'Computer Science',
    'form.step1.disciplineEngineering': 'Engineering',
    'form.step1.disciplineOther': 'Other',
    'form.step1.customDisciplinePlaceholder': 'Enter specialization (e.g. Marine Eng / Classics)',
    'form.step1.pedagogy': 'Course type',
    'form.step1.pedagogyHint': 'Multi-select; combinations drive default components.',
    'form.step1.pedagogyCase': 'Case Study',
    'form.step1.pedagogyConceptual': 'Conceptual',
    'form.step1.pedagogyQuantitative': 'Quantitative',
    'form.step1.pedagogyLab': 'Lab / Practice',
    'form.step1.pedagogyMemorization': 'Memorization',
    'form.step1.pedagogyEssay': 'Essay / Writing',
    'form.step1.pedagogyCoding': 'Coding',
    'form.step1.pedagogyCustom': 'Custom',
    'form.step1.customPedagogyPlaceholder': 'Enter custom format (e.g. Clinical / Studio Crit)',
    'form.step1.examDate': 'Exam date',
    'form.step1.examDateUnknown': 'Date TBD',
    'form.step1.examDateUnknownHint': 'You can set it later in course settings.',
    'form.step1.dateYear': 'YYYY',
    'form.step1.dateMonth': 'MM',
    'form.step1.dateDay': 'DD',
    'form.step1.masteryHeading': 'Self-assessed mastery',
    'form.step1.masteryHelp': 'Drives AI content depth + style — note granularity + question Bloom mix.',
    'form.step1.masteryNovice': 'No background',
    'form.step1.masteryNoviceDesc': 'Upload material, let AI teach — textbook-style notes + many flashcards + recall-heavy',
    'form.step1.masteryPartial': 'Partially studied',
    'form.step1.masteryPartialDesc': 'Reference book + key explanations — concepts + examples + understand-heavy',
    'form.step1.masteryReviewed': 'All lectures done',
    'form.step1.masteryReviewedDesc': 'Outline + key facts (cheat-sheet style) + analyze-heavy',
    // Session 19AE: 4-language content mode
    'form.step1.langHeading': 'Generated content language',
    'form.step1.langHelp': 'Picks which language(s) the AI generates in — questions, explanations, model answers. Chinese students preparing for English exams often benefit from bilingual scaffolding.',
    'form.step1.langEn': 'Pure English',
    'form.step1.langEnDesc': 'Questions, explanations, model answers all in English — English-medium courses',
    'form.step1.langEnZhGloss': 'English-dominant + Chinese gloss',
    'form.step1.langEnZhGlossDesc': 'Body English, key terms parenthetically glossed in Chinese (recommended)',
    'form.step1.langZhEnTerms': 'Chinese-dominant + English terms',
    'form.step1.langZhEnTermsDesc': 'Explanations in Chinese, domain terms kept English (Chinese exam + English papers)',
    'form.step1.langZh': 'Pure Chinese',
    'form.step1.langZhDesc': 'All Chinese, no English — domestic Chinese-medium courses',
    'form.step2.title': 'Exam format',
    'form.step2.heading': 'Which question types?',
    'form.step2.examFormat': 'Format mix',
    'form.step2.mcq': 'Multiple choice (MCQ)',
    'form.step2.tf': 'True / False',
    'form.step2.essay': 'Essay',
    'form.step2.shortAnswer': 'Short answer',
    'form.step2.duration': 'Duration (minutes)',
    'form.step2.mockHeading': 'Mock papers',
    'form.step2.mockHint': 'How many mock papers? Each gets independent questions (no overlap). Upload past papers in step 4 to enable strict/inspired styles.',
    'form.step2.mockNone': 'None',
    'form.step2.mockOne': '1 paper',
    'form.step2.mockTwo': '2 papers',
    'form.step2.mockThree': '3 papers',
    'form.step2.paperLabel': 'Paper',
    'form.style.contentBased': 'Content-based',
    'form.style.contentBasedDesc': 'Generated from cases + Bloom distribution',
    'form.style.pastPaperStrict': 'Strict past paper',
    'form.style.pastPaperStrictDesc': 'Match past paper count/distribution/style (questions still drawn from cases)',
    'form.style.pastPaperInspired': 'Inspired by past paper',
    'form.style.pastPaperInspiredDesc': 'Reference style; AI generates freely',
    'form.style.needsPastPaper': 'Upload a past paper in step 4 first',
    'form.step3.title': 'Components',
    'form.step3.heading': 'Which features do you want?',
    'form.step3.hint': 'Check the components you need. The AI only generates what you check — no token waste on unused features.',
    'form.step3.resetDefaults': 'Reset to recommended',
    'form.step3.resetDefaultsHint': 'Recompute the suggested set from your current Specialization × Course type. Manual edits are overwritten.',
    'form.step4.title': 'Upload',
    'form.step4.heading': 'Hand it the course material',
    'form.step4.uploadHint': 'PDF / PPTX / Word supported. Drop multiple files or a whole folder; tag each as textbook, lecture, past paper, etc.',
    'form.step4.review': 'Review',
    'form.step4.pastPapersHeading': 'Past papers (optional)',
    'form.step4.pastPapersHint': 'Upload prior exams to unlock strict/inspired mock styles. Multiple allowed; most recent year is default.',
    'form.step4.addPastPaper': '+ Add past paper',
    'form.step4.pastPaperYear': 'Year',
    'form.step4.pastPaperLabel': 'Label (optional)',
    'form.step4.pastPaperRemove': 'Remove',
    // Session 19AD: multi-source slot upload
    'form.step4.slotsHeading': 'Course material',
    'form.step4.slotsHint': 'Drop multiple files, tag each by kind — textbook / lecture / past paper / case / syllabus / reading / custom. AI dispatches by kind so it doesn\'t have to guess.',
    'form.step4.addFiles': '+ Add files',
    'form.step4.addFolder': '+ Add folder',
    'form.step4.dropZone': 'Drop files here, or click the buttons above',
    'form.step4.kindLabel': 'Kind',
    'form.step4.labelLabel': 'Label (optional)',
    'form.step4.labelPlaceholder': 'e.g. Chapter 3, 2024 final',
    'form.step4.priorityLabel': 'Priority',
    'form.step4.customNoteLabel': 'Custom note',
    'form.step4.customNotePlaceholder': 'Briefly describe this material',
    'form.step4.removeSlot': 'Remove',
    'form.step4.kind.textbook': 'Textbook',
    'form.step4.kind.lectureNotes': 'Lecture notes',
    'form.step4.kind.pastPaper': 'Past paper',
    'form.step4.kind.syllabus': 'Syllabus',
    'form.step4.kind.caseStudy': 'Case study',
    'form.step4.kind.reading': 'Reading',
    'form.step4.kind.custom': 'Custom',
    'form.step4.kind.exercise': 'Exercise',
    'form.step4.kind.rubric': 'Rubric',
    'form.step4.kind.assignment': 'Assignment',
    'form.step4.kindHelp.textbook': 'Primary textbook / chapters',
    'form.step4.kindHelp.lectureNotes': 'Slides / class notes',
    'form.step4.kindHelp.pastPaper': 'Prior exam papers',
    'form.step4.kindHelp.syllabus': 'Course outline',
    'form.step4.kindHelp.caseStudy': 'Case readings (Harvard etc.)',
    'form.step4.kindHelp.reading': 'Supplementary reading',
    'form.step4.kindHelp.custom': 'Other (note required)',
    'form.step4.kindHelp.exercise': 'Problem sets / practice drills',
    'form.step4.kindHelp.rubric': 'Grading scheme / answer key',
    'form.step4.kindHelp.assignment': 'Coursework / homework',
    'form.step4.formatBadge.pdf': 'PDF',
    'form.step4.formatBadge.pptx': 'PPTX',
    'form.step4.formatBadge.docx': 'Word',
    'form.step4.formatBadge.md': 'Markdown',
    'form.step4.formatBadge.txt': 'Text',
    'form.step4.unsupportedFormat': 'Unsupported format',
    'form.step4.parseError': 'Parse failed',
    // Home / course list
    'home.title': 'My Courses',
    'home.subtitle': 'Turn course material into a one-shot exam prep artifact.',
    'home.empty': 'No courses yet',
    'home.emptyHint': 'Upload a course material to start your first exam prep artifact.',
    'home.openCourse': 'Open',
    'create.saveDraftFailed': 'Failed to save course draft: {message}',
    'schemaVersion.needRegen': 'This module needs regenerated course content to unlock.',
    'schemaVersion.minRequired': 'Minimum required schema {required}',
    'schemaVersion.currentVersion': 'current {actual}',
    'schemaVersion.currentUndefined': 'current version not declared',
    'home.draftMeta': 'Saved · not generated',
    // Course view
    'course.loading': 'Loading course…',
    'course.notFound': 'Course not found',
    'course.notFoundHint': 'It may have been deleted, or the link is from another device.',
    'course.backHome': 'Back to home',
    'sidebar.courseCode': 'Course code',
    'sidebar.courseCodeUnset': 'No course code set',
    'resultView.noCases': 'No cases generated.',
    'resultView.noFlashcards': 'No flashcards generated.',
    'resultView.noMcqs': 'No MCQs generated.',
    'course.generateHeading': 'Ready to generate',
    'course.generateBody': 'Click below — the AI will read the PDF and produce content for the components you selected. Takes ~30 seconds to a few minutes.',
    'course.generateNow': 'Generate now',
    'course.generating': 'Generating…',
    'course.generatingHint': 'The AI is parsing the PDF and producing flashcards, questions, and explanations. Please wait.',
    'course.regenerate': 'Generate content',
    'course.regenerateConfirm': 'This overwrites the existing content. Continue?',
    'course.errorHeading': 'Generation failed',
    'course.errorRetry': 'Retry',
    'course.uploadMissing': 'Source PDF not found. Browser storage may have been cleared. Please recreate the course.',
    'course.pasteJsonAlt': 'Already have generated content? Paste it here',
    'course.pasteJsonHeading': 'Paste pre-generated course content',
    'course.pasteJsonHint': "If you've generated course data with another tool (e.g. Claude.ai), paste it here to skip local generation.",
    'course.pasteJsonHintSchema': 'Must include: course id, title, chapters (≥1), flashcards and MCQs; other types (true/false, essays, glossary, mind maps, proofs) are optional.',
    'course.pasteJsonPlaceholder': 'Paste course content here…',
    'course.pasteJsonValidateAndSave': 'Validate & save',
    'course.pasteJsonInvalid': 'Content is not valid (parse error)',
    'course.pasteJsonValidationFailed': 'Content does not match the expected structure',
    'course.pasteJsonLegacyMigrated': 'Detected legacy fields, auto-migrated: {rules}',
    'course.skipReview': 'Skip review (auto)',
    'course.extractingOutline': 'Extracting outline...',
    'course.extractingOutlineHint': 'AI is analysing your source material — this may take a few minutes',
    'course.cancel': 'Cancel',
    'course.previewTab': 'Raw',
    // Dashboard
    'dashboard.daysUntilExam': 'days until exam',
    'dashboard.examComingSoon': 'coming soon',
    'dashboard.examPassed': 'exam passed',
    'dashboard.examToday': 'exam today',
    'dashboard.flashcardsDue': 'cards due',
    'dashboard.flashcardsTotal': 'of {count} total',
    'dashboard.wrongAnswersUnresolved': 'unresolved',
    'dashboard.recommendedNext': 'Recommended next',
    'dashboard.openModule': 'Open',
    'dashboard.noActivityYet': "No activity yet — open any module to start.",
    'dashboard.viewByChapter': 'By Chapter',
    'dashboard.viewByTopic': 'By Topic',
    'dashboard.chapterBreakdown': 'Chapter breakdown',
    'dashboard.topicBreakdown': 'Topic breakdown',
    'dashboard.weakestChapters': 'Weakest chapters',
    'dashboard.weakestTopics': 'Weakest topics',
    'dashboard.cognitiveDistribution': 'Cognitive level distribution',
    'dashboard.cognitiveDistributionHelp': 'Questions classified by Bloom taxonomy: Recall / Understand / Apply / Analyze / Evaluate. Further right means more depth.',
    'dashboard.cogRecall': 'Recall',
    'dashboard.cogUnderstand': 'Understand',
    'dashboard.cogApply': 'Apply',
    'dashboard.cogAnalyze': 'Analyze',
    'dashboard.cogEvaluate': 'Evaluate',
    'dashboard.cogUnlabeled': 'Unlabeled',
    // ── 19BO+ B5.3 chapter × cognitive-level heatmap ──
    'dashboard.heatmapTitle': 'Chapter × Cognitive Level Error Heatmap',
    'dashboard.heatmapHelp': 'Darker cells mean more unresolved wrong answers for that chapter and cognitive level. Click a chapter to expand practice links.',
    'dashboard.heatmapExpandHint': 'click to expand',
    'dashboard.heatmapCellTitle': '{chapter} · {level}: {unresolved} unresolved / {total} ever wrong',
    'dashboard.heatmapPracticeFlashcard': 'Practice flashcards',
    'dashboard.heatmapPracticeQuiz': 'Practice quiz',
    'dashboard.mastery': 'Mastery',
    'dashboard.noTopicsYet': "No topic-level data — this course was generated before topic labels existed. Re-run content generation to unlock the topic view.",
    'dashboard.dueShort': 'due',
    'dashboard.unresolvedShort': 'wrong',
    'dashboard.bookmarkedShort': 'saved',
    'dashboard.itemsShort': 'items',
    'dashboard.showContents': 'Show contents',
    'dashboard.hideContents': 'Hide contents',
    'dashboard.essaysDrafted': 'essays drafted',
    'dashboard.itemKindTf': 'True/False',
    'dashboard.itemKindNote': 'Lecture note',
    'dashboard.familyGenerative': 'Study materials',
    'dashboard.familyDiscrimination': 'Test yourself',
    'dashboard.familySynthesis': 'Essay drills',
    // 19BO+ Line 2 B4.3 · AI 弱项诊断触发
    'dashboard.diagnoseBtn': 'Diagnose weak points',
    'dashboard.diagnoseRescoreBtn': 'Re-diagnose',
    // Mock exam
    'mockExam.heading': 'Mock Exam',
    'mockExam.setupHeading': 'Mock exam ready',
    'mockExam.setupBody': 'Timer starts on click. No pause — same as the real exam. You can mark questions for review and revisit before submit.',
    'mockExam.formatLine': 'Format: {format}',
    'mockExam.durationLine': 'Duration: {minutes} minutes',
    'mockExam.start': 'Start',
    'mockExam.empty': 'Mock exam not enabled',
    'mockExam.emptyHint': "Enable the Mock Exam component on the components step and generate.",
    'mockExam.timeRemaining': '{time} left',
    'mockExam.timeUp': "Time's up — auto-submitted",
    'mockExam.questionNum': 'Q{n}',
    'mockExam.markReview': 'Mark for review',
    'mockExam.unmarkReview': 'Unmark',
    'mockExam.tfTrue': 'TRUE',
    'mockExam.tfFalse': 'FALSE',
    'mockExam.submit': 'Submit',
    'mockExam.submitConfirm': '{remaining} questions unanswered. Submit anyway?',
    'mockExam.finishedHeading': 'Submitted',
    'mockExam.finishedScore': 'Score: {correct} / {total} ({percent}%) · {minutes} min used',
    'mockExam.finishedReview': 'Review answers',
    'mockExam.finishedRestart': 'Run again',
    'mockExam.finishedHome': 'Back to dashboard',
    'mockExam.statAnswered': '{n} answered',
    'mockExam.statMarked': '{n} marked',
    'mockExam.statRemaining': '{n} unanswered',
    'mockExam.paperCountQ': 'How many papers?',
    'mockExam.paperCountHint': 'Each paper is sampled independently; complete them separately. Max 3 (warned if pool is too small).',
    'mockExam.generate': 'Generate {n} paper(s)',
    'mockExam.pickPaperHeading': 'Pick a paper',
    'mockExam.pickPaperBody': '{n} independent papers ready. Click to start.',
    'mockExam.paperLabel': 'Paper {n}',
    'mockExam.paperItems': '{n} questions',
    'mockExam.paperPending': 'Pending',
    'mockExam.paperDone': 'Done',
    'mockExam.paperScore': '{correct}/{total}',
    'mockExam.openPaper': 'Open',
    'mockExam.backToPicker': 'Back to papers',
    'mockExam.nextPaper': 'Next paper',
    'mockExam.unconfiguredHeading': 'Mock exam not configured yet',
    'mockExam.unconfiguredBody': 'Paper count and style live in course settings — head over, configure, and return to take the exam.',
    'mockExam.goToSettings': 'Open course settings',
    'mockExam.openSettings': 'Course settings',
    'mockExam.createPaper': 'Create Mock Paper',
    'mockExam.regenerateSample': 'Resample papers',
    'mockExam.regenerateSampleHint': 'Re-sample papers from current question bank (does not change CourseDraft config).',
    'mockExam.prevItem': 'Previous',
    'mockExam.nextItem': 'Next',
    'mockExam.reviewHeading': 'Review by question',
    'mockExam.reviewCorrect': 'Correct',
    'mockExam.reviewWrong': 'Wrong',
    'mockExam.reviewUnanswered': 'Unanswered',
    'mockExam.reviewAnswer': 'Answer',
    'mockExam.reviewYourAnswer': 'Your answer',
    'mockExam.reviewExplanation': 'Explanation',
    'mockExam.essayLabel': 'Essay',
    'mockExam.essayScaffold': 'Scaffold',
    'mockExam.essayKeyPoints': 'Key points',
    'mockExam.essayModelAnswer': 'Model answer',
    // Mindmap
    'mindmap.heading': 'Mind Map',
    'mindmap.empty': 'No mind maps',
    'mindmap.emptyHint': "This course wasn't generated with mind maps. Enable the mindmap component and generate.",
    'mindmap.pickCase': 'Choose chapter',
    'mindmap.toolbarReset': 'Center',
    'mindmap.toolbarFit': 'Fit',
    // Essay
    'essay.heading': 'Essay Drill',
    'essay.empty': 'No essays',
    'essay.notFound': 'Essay not found',
    'essay.emptyHint': "This course wasn't generated with essays. Enable the essay component and generate.",
    'essay.colPrompt': 'Prompt',
    'essay.colCase': 'Case',
    'essay.colWordTarget': 'Target',
    'essay.colStatus': 'Status',
    'essay.statusEmpty': 'Not started',
    'essay.statusDraft': 'Draft',
    'essay.statusGraded': 'Graded',
    'essay.detailPrompt': 'Prompt',
    'essay.detailScaffold': 'Scaffold',
    'essay.detailModelAnswer': 'Model answer',
    'essay.detailKeyPoints': 'Key points',
    'essay.editorTitle': 'My answer',
    'essay.editorPlaceholder': 'Write your essay here…',
    'essay.wordCount': '{n} words',
    'essay.wordTargetLabel': 'target {n}',
    'essay.savedAt': 'saved · {time}',
    'essay.copyMd': 'Copy markdown',
    'essay.copyHtml': 'Copy HTML',
    'essay.exportMd': 'Download .md',
    'essay.copied': 'Copied ✓',
    'essay.aiScoreBtn': 'AI grade',
    'essay.aiScoreTooltip': 'Premium feature · token-billed',
    'essay.aiScoreFuture': 'Premium feature: AI auto-grading is token-billed. Free tier compares against the reference answer + key points for self-assessment.',
    'essay.toolbarBold': 'Bold',
    'essay.toolbarItalic': 'Italic',
    'essay.toolbarH1': 'H1',
    'essay.toolbarH2': 'H2',
    'essay.toolbarList': 'List',
    'essay.toolbarOrdered': 'Ordered',
    'essay.toolbarQuote': 'Quote',
    'essay.toolbarCode': 'Code',
    'essay.toolbarLink': 'Link',
    'essay.backToList': '← Back to list',
    // Flashcards
    'flashcards.heading': 'Flashcards',
    'flashcards.empty': 'No flashcards',
    'flashcards.emptyHint': "This course wasn't generated with flashcards. Toggle the flashcards component on and generate.",
    'flashcards.reviewAll': 'Review all',
    'flashcards.flipHint': 'Space / Enter to flip',
    'flashcards.rateAgain': 'Again',
    'flashcards.rateHard': 'Hard',
    'flashcards.rateGood': 'Good',
    'flashcards.rateEasy': 'Easy',
    'flashcards.cardCounter': 'Card {current} of {total}',
    'flashcards.boxLabel': 'Box',
    'flashcards.filterByCase': 'Filter by case',
    'flashcards.allCases': 'All',
    'flashcards.sessionDone': 'Session complete',
    'flashcards.sessionDoneHint': 'All due cards reviewed for now. Head back to the dashboard or jump to quiz.',
    'flashcards.sessionCorrect': '{good} of {total} cards rated Good or above this session.',
    'flashcards.startNew': 'Start new session',
    'flashcards.shortcuts': 'Keys: Space/Enter to flip · 1 Again · 2 Hard · 3 Good · 4 Easy',
    // Quiz
    'quiz.heading': 'Quiz',
    'quiz.setupHeading': 'Configure this session',
    'quiz.pickCase': 'Scope',
    'quiz.pickCount': 'Questions',
    'quiz.start': 'Start',
    'quiz.empty': 'No questions',
    'quiz.emptyHint': "This course wasn't generated with MCQs. Enable the Quiz component and generate.",
    'quiz.questionCounter': 'Question {current} of {total}',
    'quiz.correct': 'Correct',
    'quiz.incorrect': 'Incorrect',
    'quiz.explanation': 'Explanation',
    'quiz.showAnswer': 'Show answer',
    'quiz.nextQuestion': 'Next question',
    'quiz.finishedHeading': 'Session complete',
    'quiz.finishedScore': 'Score: {correct} / {total} ({percent}%)',
    'quiz.finishedReviewWrong': 'Review wrong answers',
    'quiz.finishedRestart': 'Run another',
    'quiz.finishedBackToHub': 'Back to dashboard',
    'quiz.shortcuts': 'Keys: A/B/C/D or 1/2/3/4 to select · → next',
    // Glossary (Session 19X · v1↔v2 parity)
    'glossary.heading': 'Glossary',
    'glossary.subtitle': 'Quick term lookup — search, jump by letter, filter by chapter.',
    'glossary.empty': 'Glossary is empty',
    'glossary.emptyHint': 'No terms yet for this course. Re-run content generation to populate.',
    'glossary.searchPlaceholder': 'Search terms / definitions…  (press / to focus)',
    'glossary.filterAllCases': 'All chapters',
    'glossary.filterUnscoped': 'Unscoped',
    'glossary.alphaIndex': 'Alpha index',
    'glossary.noMatches': 'No matching terms.',
    'glossary.totalTerms': '{count} terms',
    'glossary.relatedCases': 'Related chapters',
    'glossary.shortcutFocusSearch': 'Press / to focus search',
    'glossary.expandAll': 'Expand all',
    'glossary.collapseAll': 'Collapse all',
    // Bookmarks
    'bookmarks.heading': 'Bookmarks',
    'bookmarks.subtitle': 'Items you starred — regardless of whether you got them right.',
    'bookmarks.empty': 'No bookmarks yet',
    'bookmarks.emptyHint': 'Tap the bookmark icon in flashcards or quiz to save items here.',
    'bookmarks.addBookmark': 'Add bookmark',
    'bookmarks.removeBookmark': 'Remove bookmark',
    'bookmarks.filterAll': 'All',
    'bookmarks.filterMcq': 'Questions',
    'bookmarks.filterFlashcard': 'Flashcards',
    'bookmarks.colItem': 'Item',
    'bookmarks.colCase': 'Case',
    'bookmarks.colType': 'Type',
    'bookmarks.colAddedAt': 'Saved',
    'bookmarks.typeMcq': 'Question',
    'bookmarks.typeFlashcard': 'Flashcard',
    'bookmarks.drillSelected': 'Drill selected',
    'bookmarks.drillAll': 'Drill bookmarks',
    // Quiz resume
    'quiz.resumeHeading': 'Unfinished session detected',
    'quiz.resumeBody': "You stopped at question {current} / {total}. Resume?",
    'quiz.resumeContinue': 'Resume',
    'quiz.resumeAbandon': 'Abandon and restart',
    'quiz.resumeAbandonConfirm': 'Abandon current progress and restart from setup?',
    // Wrong answers
    'wrongAnswers.heading': 'Wrong Answers',
    'wrongAnswers.subtitle': 'Auto-tracked items you got wrong. An item is "resolved" once correct attempts ≥ wrong attempts.',
    'wrongAnswers.empty': 'No wrong answers yet',
    'wrongAnswers.emptyHint': 'Run a quiz session — anything you miss appears here automatically.',
    'wrongAnswers.filterAll': 'All',
    'wrongAnswers.filterUnresolved': 'Unresolved',
    'wrongAnswers.filterResolved': 'Resolved',
    'wrongAnswers.colQuestion': 'Question',
    'wrongAnswers.colCase': 'Case',
    'wrongAnswers.colStatus': 'Status',
    'wrongAnswers.colWrong': 'Wrong',
    'wrongAnswers.colCorrect': 'Right',
    'wrongAnswers.colLastWrong': 'Last wrong',
    'wrongAnswers.statusUnresolved': 'Unresolved',
    'wrongAnswers.statusResolved': 'Resolved',
    'wrongAnswers.drillSelected': 'Drill selected',
    'wrongAnswers.drillAll': 'Drill all unresolved',
    // Health badge
    'health.idle': 'Idle',
    'health.checking': 'Checking…',
    'health.ok': 'Online',
    'health.degraded': 'Slow',
    'health.offline': 'Offline',
    'health.notConnected': 'Generator not connected',
    'health.pasteJsonMode': 'Pasted content · offline OK',
    // Theme toggle (session 42)
    'theme.light': 'Light mode',
    'theme.dark': 'Dark mode',
    'theme.system': 'System',
    // Auth / account stub (session 43)
    'auth.login': 'Sign in',
    'auth.logout': 'Sign out',
    'auth.anonymous': 'Anonymous',
    'auth.profile': 'Profile',
    // auth (19BN Phase 1 expansion)
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.confirmPassword': 'Confirm password',
    'auth.displayName': 'Display name (optional)',
    'auth.inviteCode': 'Invite code (optional)',
    'auth.welcome': 'Welcome back',
    'auth.createAccount': 'Create account',
    'auth.signUp': 'Sign up',
    'auth.orDivider': 'or',
    'auth.magicLinkLogin': 'Sign in with email link',
    'auth.haveAccount': 'Already have an account?',
    'auth.noAccount': "Don't have an account?",
    'auth.forgotPassword': 'Forgot password?',
    'auth.sending': 'Submitting…',
    'auth.loginFailed': 'Invalid email or password',
    'auth.emailTaken': 'Email already registered',
    'auth.weakPassword': 'Password must be at least 8 characters',
    'auth.invalidEmail': 'Please enter a valid email',
    'auth.passwordMismatch': 'Passwords do not match',
    'auth.changePassword': 'Change password',
    'auth.currentPassword': 'Current password',
    'auth.newPassword': 'New password (8+ chars)',
    'auth.passwordChanged': 'Password changed',
    'auth.loginSuccess': 'Signed in',
    'auth.logoutConfirm': 'Sign out?',
    'auth.signupSuccess': 'Account created',
    'auth.welcomeBonus': 'Get 1,000 points on signup',
    'auth.welcomeBonusSub': 'Enough for 5-6 full course builds',
    'auth.magicSent': 'Verification email sent',
    'auth.magicSentHint': 'We sent a sign-in link to your email. Valid for 15 minutes. Check spam if missing.',
    'auth.resend': 'Resend',
    'auth.magicVerifySuccess': 'Signed in',
    'auth.magicVerifyFailed': 'Link expired or invalid',
    'auth.magicVerifyPending': 'Signing you in…',
    'auth.magicVerifyFailedHint': 'This sign-in link is invalid, expired, or already used. Please request a new link.',
    // 19BO+ Phase B: two-stage signup (request → email-confirmed login)
    'auth.signupSent': 'Verification email sent',
    'auth.signupSentHint': 'We sent a confirmation link to your email. Click it to finish creating your account. Valid for 15 minutes. Check spam if missing.',
    'auth.signupVerifyPending': 'Confirming your account…',
    'auth.signupVerifySuccess': 'Account created',
    'auth.signupVerifyFailed': 'Link expired or invalid',
    'auth.signupVerifyFailedHint': 'This confirmation link is invalid, expired, or already used. Please sign up again to get a new link.',
    'auth.wrongCurrentPassword': 'Current password is incorrect',
    'auth.agreeTerms': 'I agree to the Terms of Service',
    'auth.viewPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.pwStrengthWeak': 'weak',
    'auth.pwStrengthMedium': 'medium',
    'auth.pwStrengthStrong': 'strong',
    'auth.pwMinLength': '8+ characters',
    // account (19BN Phase 2)
    'account.myPoints': 'My points',
    'account.points': 'pts',
    'account.coursesWorth': 'full courses',
    'account.recharge': 'Recharge',
    'account.balance': 'Point balance',
    'account.insufficientCredits': 'Insufficient credits. Please recharge.',
    'account.viewHistory': 'View history',
    'account.creditsHistory': 'Credits history',
    'account.lowBalanceTitle': 'Point balance is low',
    'account.lowBalanceBody': 'Current balance {balance} pts, below the alert threshold ({threshold} pts). Consider recharging.',
    // Regen view
    'regen.title': 'Content Generation',
    'regen.tabPartial': 'Batch',
    'regen.tabHistory': 'History',
    'regen.tabSettings': 'Settings',
    'regen.fullDesc': 'Re-extract outline → confirm → full pipeline. Overwrites all existing content.',
    'regen.fullStart': 'Start full content generation',
    'regen.partialStart': 'Start',
    'regen.preparing': 'Preparing…',
    'regen.runningJob': 'Generating {stage}… ({done}/{total})',
    'regen.generating': 'Generating…',
    'regen.done': 'Generation complete',
    'regen.failed': 'Generation failed',
    'regen.reset': 'Reset',
    'regen.selectChapters': 'Chapters',
    'regen.selectStages': 'Stages',
    'regen.selectAll': 'Select All',
    'regen.deselectAll': 'Deselect All',
    'regen.historyDesc': 'View and rollback past content generation operations.',
    'regen.historyLoading': 'Loading…',
    'regen.historyEmpty': 'No history yet',
    'regen.rollback': 'Undo',
    'regen.rollbackConfirm': 'Confirm rollback? Generated content will be restored to previous state.',
    'regen.replaceLabel': 'Replace',
    'regen.addLabel': 'Add',
    'regen.deleteLabel': 'Delete',
    'regen.fixLabel': 'Fix',
    'regen.statusApplied': 'Applied',
    'regen.statusPending': 'Pending',
    'regen.statusRejected': 'Rejected',
    'regen.statusRolledBack': 'Rolled back',
    'regen.appliedN': 'Applied {n} items',
    'regen.noChapters': 'No chapters — generate content first',
    'regen.historyLoadFailed': 'Failed to load history: {error}',
    'regen.historyDbUnavailable': 'History requires D1 database — not available in local dev without D1 binding',
    // Regen settings
    'regen.settingsAutoApply': 'Auto-apply',
    'regen.settingsAutoApplyDesc': 'Skip preview and apply regen results directly.',
    'regen.settingsAutoApplyWarn': 'When enabled, generated items replace originals immediately without per-item review.',
    'regen.settingsAddCount': 'Default add count',
    'regen.settingsAddCountDesc': 'Number of items generated when using "Generate more".',
    // Item action menu (embedded regen · session 19BJ)
    'itemAction.buttonLabel': 'Generate content',
    'itemAction.replace': 'Regenerate this item',
    'itemAction.addMore': 'Generate more like this',
    'itemAction.delete': 'Delete this item',
    'itemAction.hint': 'Regenerate with hint…',
    'itemAction.hintPlaceholder': 'Enter your hint or requirements…',
    'itemAction.cancel': 'Cancel',
    'itemAction.generate': 'Generate',
    // Notification center / Message center
    'notif.centerTitle': 'Notifications',
    'notif.messageCenter': 'Message Center',
    'notif.empty': 'No notifications',
    'notif.emptyHint': 'System messages will appear here.',
    'notif.emptyFiltered': 'No notifications in this category',
    'notif.markAllRead': 'Mark all read',
    'notif.clearAll': 'Clear all',
    'notif.viewAll': 'View all',
    'notif.tabAll': 'All',
    'notif.tabStudy': 'Study',
    'notif.tabSystem': 'System',
    'notif.tabAccount': 'Account',
    // Regen notifications
    'regen.notifStarted': 'Started generating {stage}',
    'regen.notifCompleted': '{stage} complete · {count} items · {duration}',
    'regen.notifFailed': '{stage} generation failed',
    'regen.notifInterrupted': '{stage} generation interrupted by page refresh — please restart',
    'regen.notifView': 'View',
    'ingest.title': 'Generating course content',
    'ingest.hint': "Content is built step by step — please keep this tab open. Usually takes 10-30 minutes depending on enabled components and source material size. Please be patient.",
    'ingest.statusSkipped': 'Skipped',
    'ingest.statusError': 'Failed',
    'ingest.errorsSummary': 'Failed steps',
    'ingest.stage.parseFiles': 'Reading uploaded files',
    'ingest.stage.bundlePastPapers': 'Organizing past papers',
    'ingest.stage.extractCases': 'Extracting chapter structure',
    'ingest.stage.flashcards': 'Generating flashcards',
    'ingest.stage.mcqs': 'Generating multiple-choice',
    'ingest.stage.trueFalse': 'Generating true/false',
    'ingest.stage.essays': 'Generating essays',
    'ingest.stage.mindmaps': 'Generating mind maps',
    'ingest.stage.glossary': 'Generating glossary',
    'ingest.stage.lectureNotes': 'Generating notes',
    'ingest.stage.proofDrills': 'Generating proof drills',
    'ingest.stage.freeResponses': 'Generating free response',
    'ingest.stage.readingPassages': 'Generating reading',
    'ingest.stage.mockPapers': 'Generating mock papers',
    'ingest.stage.audit': 'Quality check',
    // Session 19AE: skip-reason copy
    'ingest.skipReason.noFiles': 'no files uploaded',
    'ingest.skipReason.noPastPaper': 'no past papers uploaded',
    'ingest.skipReason.componentDisabled': 'component disabled',
    'ingest.skipReason.noMockSpec': 'no mock paper configured',
    'ingest.skipReason.outlineLocked': 'outline locked',
    // Session 19AE: lecture-notes-view
    'lectureNotes.empty': 'No lecture notes',
    'lectureNotes.emptyHint': 'Enable the "Lecture notes" component and generate content to get notes.',
    'lectureNotes.keyPointsHeading': 'Key takeaways',
    'lectureNotes.relatedGlossary': 'Related terms',
    'lectureNotes.source': 'Source',
    'lectureNotes.likelihoodHigh': 'High exam likelihood',
    'lectureNotes.likelihoodMid': 'Medium exam likelihood',
    'lectureNotes.likelihoodLow': 'Low exam likelihood',
    // Session 19AH: proof-drills-view
    'proofDrills.empty': 'No proof drills',
    'proofDrills.emptyHint': 'Enable the "Proof Drill" component and generate content to get drills for this chapter.',
    'proofDrills.keyStepsHeading': 'Derivation steps',
    'proofDrills.commonMistakesHeading': 'Common mistakes',
    // Session 19AN: progressive step reveal
    'proofDrills.revealStep': 'Reveal this step',
    'proofDrills.revealAll': 'Reveal all steps',
    'proofDrills.hideAll': 'Hide all steps',
    'proofDrills.stepLabel': 'Step {n}',
    'proofDrills.tryFirst': 'Try to derive it yourself first; reveal each step when stuck.',
    'proofDrills.justificationLabel': 'Why this step holds',
    // Session 19AN: stale state banner
    'course.staleBanner': 'Course parameters changed (sources / discipline / pedagogy / mock config). Existing content may be out of sync.',
    'course.staleRegenerate': 'Generate content',
    // Session 19AO: subjective wrong-answers tab + stats
    'wrongAnswers.tabObjective': 'Objective (MCQ / T/F)',
    'wrongAnswers.tabSubjective': 'Subjective (essay / short / derivation)',
    'wrongAnswers.subjectiveEmpty': 'No subjective attempts yet. Go to essay / free-response / proof-drill to write and self-grade.',
    'wrongAnswers.subjectiveStatTotal': 'Attempted',
    'wrongAnswers.subjectiveStatNeedsRevisit': 'Needs revisit (avg <2/3)',
    'wrongAnswers.subjectiveStatByType': 'By type',
    'wrongAnswers.subjectiveWeakest': 'Weakest (by latest avg)',
    // Session 19AP: shared self-assess panel
    'essay.selfAssessHeading': 'Self-assess your answer',
    'essay.selfAssessHint': '0=missed / 1=partial / 2=mostly / 3=fully met. Honest scoring is itself the practice.',
    'proofDrills.selfAssessHeading': 'Self-assess your derivation',
    'proofDrills.selfAssessHint': '0=wrong direction / 1=stuck mid-way / 2=mostly sound / 3=every step holds.',
    // Session 19AP: dashboard subjective summary
    'dashboard.subjectiveAvg': 'Self-score {avg}/3',
    'dashboard.subjectiveNeedsRevisit': 'to revisit',
    // Session 19AN: free-response view
    'freeResponse.empty': 'No free-response items',
    'freeResponse.emptyHint': 'Enable the "Free Response" component and generate to get items.',
    'freeResponse.kind.short_answer': 'Short answer',
    'freeResponse.kind.calculation': 'Calculation',
    'freeResponse.kind.translation': 'Translation',
    'freeResponse.scaffoldHeading': 'Suggested structure',
    'freeResponse.hintsHeading': 'Progressive hints',
    'freeResponse.hintsEmpty': 'Click below to reveal hints one by one.',
    'freeResponse.revealHint': 'Reveal hint {n}/{total}',
    'freeResponse.responseHeading': 'Your answer',
    'freeResponse.responsePlaceholder': 'Type your answer here. Markdown / LaTeX ($...$, $$...$$) supported.',
    'freeResponse.commit': 'Commit + reveal reference',
    'freeResponse.commitEmptyConfirm': 'Answer is empty. Commit anyway?',
    'freeResponse.reset': 'Reset',
    'freeResponse.resetConfirm': 'Reset clears your answer and self-assessment. Continue?',
    'freeResponse.referenceHeading': 'Reference answer',
    'freeResponse.reasoningHeading': 'Reasoning',
    'freeResponse.finalValueLabel': 'Final value',
    'freeResponse.sourceTextHeading': 'Source text',
    'freeResponse.targetLanguage': 'Target language: {lang}',
    'freeResponse.selfAssessHeading': 'Self-assessment · score 0-3 per dimension',
    'freeResponse.selfAssessHint': '0=not met, 1=partial, 2=mostly met, 3=fully met. Honest self-grading is the core exercise.',
    // Session 19AN: reading-passage view
    'readingPassage.empty': 'No reading passages',
    'readingPassage.emptyHint': 'Enable the "Reading Passage" component and generate to get passages.',
    'readingPassage.passageHeading': 'Passage',
    'readingPassage.questionsHeading': 'Linked questions',
    'readingPassage.wordCount': '~{n} words',
    'readingPassage.sourceCredit': 'Source: {credit}',
    // Session 19AE: progress detail UI
    'ingest.totalElapsed': 'Elapsed',
    'ingest.aiCallBadge': 'This stage calls AI',
    'ingest.recoverableSingle': '1 stage failed but recoverable — pipeline continues',
    'ingest.recoverableMulti': '{n} stages failed but recoverable — pipeline continues',
    'ingest.finalizing': 'Finalizing quality checks…',
    'ingest.group.prep': 'Preparation',
    'ingest.group.generate': 'AI generation',
    'ingest.group.qa': 'Quality check',
    'ingest.group.doneSummary': '{n} items completed',
    'ingest.group.inProgress': 'In progress…',
    'ingest.hero.running': '{stage}',
    'ingest.hero.runningHint': 'This stage typically takes {min}-{max} minutes',
    'ingest.hero.done': 'Finishing up…',
    'ingest.hero.elapsedLabel': 'Elapsed',
    'ingest.lowYield': 'Limited source',
    'ingest.lowYieldTip': 'Source material was limited — generated as many items as possible. Some modules have fewer items than ideal.',
    'ingest.lowYieldBannerSingle': '{stage} has fewer items than expected — source material was limited.',
    'ingest.lowYieldBannerMulti': '{n} modules have fewer items than expected — source material was limited.',
    'mockExam.styleStrict': 'Strict past paper',
    'mockExam.styleInspired': 'Inspired by past paper',
    'mockExam.styleContent': 'Content-based',
    'mockExam.fallbackBanner': '⚠ Independent mock items not generated or insufficient — sampling from daily bank as fallback. Re-run content generation to retry mock_papers stage.',
    'wrongAnswers.statsHeading': 'Wrong-answer stats',
    'wrongAnswers.statTotal': 'Total',
    'wrongAnswers.statUnresolved': 'Unresolved',
    'wrongAnswers.statResolved': 'Resolved',
    'wrongAnswers.statByCase': 'By chapter',
    'wrongAnswers.statByCategory': 'By category',
    'wrongAnswers.statTrend': 'Last {n} days',
    'wrongAnswers.trendAxis': 'Last {n} days (left=oldest, right=newest)',
    // Footer (session 44)
    'footer.allRightsReserved': 'All rights reserved.',
    'footer.email': 'Email',
    'footer.wechat': 'WeChat',
    'footer.bilibili': 'Bilibili',
    'footer.douyin': 'Douyin',
    'footer.xiaohongshu': 'Xiaohongshu',
    // Subjective feedback (19BM-F · Cmd+/ hotkey · progressive 3-state panel)
    'feedback.title': 'Feedback',
    'feedback.subtitle': 'What feels off?',
    'feedback.categoryOff': 'Something off',
    'feedback.categoryMissing': 'Missing a feature',
    'feedback.categorySlow': 'Too slow',
    'feedback.categoryOther': 'Other',
    'feedback.noteLabel': 'Note (optional)',
    'feedback.notePlaceholder': 'Add details (≤500 chars)',
    'feedback.submit': 'Submit feedback',
    'feedback.expand': 'Add details',
    'feedback.collapse': 'Collapse',
    'feedback.submitted': 'Recorded, thank you',
    'feedback.duplicate': 'Already submitted just now — try again later',
    'feedback.failed': 'Failed to record — please retry',
    // ── Admin: usage-page (19BM-D · /admin?key=... cross-user D1 dashboard) ─
    'admin.title': 'Cram & Toss · Operator dashboard',
    'admin.subtitle': 'ExamForge admin · cross-user telemetry from D1 · full observability of friend-alpha quality + cost + flags',
    'admin.tab.overview': 'Overview',
    'admin.tab.users': 'Users',
    'admin.tab.ingests': 'Ingests',
    'admin.tab.repairs': 'Repairs',
    'admin.tab.feedback': 'Feedback',
    'admin.tab.events': 'Events',
    'admin.search.hint': 'Search anon_id / course / item_id / summary',
    'admin.search.placeholder.default': 'Search…',
    'admin.search.placeholder.users': 'Search anon_id or course name…',
    'admin.search.placeholder.ingests': 'Search anon_id / course / error_code / stage…',
    'admin.search.placeholder.repairs': 'Search anon_id or kind…',
    'admin.search.placeholder.feedback': 'Search anon_id / course / item_id / note…',
    'admin.search.placeholder.events': 'Search anon_id / course / summary / view…',
    'admin.stat.totalIngest': 'Total ingests',
    'admin.stat.totalIngestSub': '24h: {count}',
    'admin.stat.totalCost': 'Total cost',
    'admin.stat.totalCostSub': '24h: ${cost}',
    'admin.stat.distinctUsers': 'Distinct users',
    'admin.stat.flagTotal': '🚩 Total flags',
    'admin.stat.flagTotalSub': '24h: {count}',
    'admin.stat.avgRating': '⭐ Avg rating',
    'admin.stat.avgRatingSub': '{count} ratings',
    'admin.stat.runtimeErrors': 'Runtime errors',
    'admin.stat.runtimeErrorsSub': '24h: {count}',
    'admin.col.type': 'Type',
    'admin.col.count': 'Count',
    'admin.col.field': 'Field',
    'admin.col.itemCount': 'Items',
    'admin.col.firstSample': 'First sample',
    'admin.empty.noEvents': 'No events — appears after friends drill / flag / trigger errors',
    'admin.empty.noUsers': 'No matching users',
    'admin.empty.noIngests': 'No matching ingests',
    'admin.empty.noRepairs': 'No repair records',
    'admin.empty.noFeedback': 'No flags / ratings / notes yet. Friends can submit via the 🏳 button next to an item.',
    'admin.empty.noMatchingEvents': 'No matching events',
    'admin.action.refresh': '↻ Refresh',
    'admin.action.localView': 'Local view',
    'admin.action.localViewTitle': 'Local IDB view (your browser only)',
    'admin.action.downloadJson': '↓ Download full JSON',
    'admin.action.expand': 'More',
    'admin.action.collapse': 'Less',
    'admin.error.missingKey': 'Missing ?key= query parameter',
    'admin.error.unauthorized': 'Unauthorized (404 — wrong or missing key)',
    'admin.error.d1NotBound': 'D1 not bound on worker — run migrations first',
    'admin.notice.missingKey': 'Append <code>?key=&lt;ADMIN_KEY&gt;</code> to the URL.',
    'admin.notice.errorPrefix': 'Error: ',
    'admin.notice.loading': 'Loading…',
    'admin.section.eventTypeDistribution': 'Event type distribution',
    'admin.section.recentIngests': 'Recent {count} ingests',
    'admin.tooltip.inferredErrorCode': 'Inferred (worker finally did not run → checkpoint stale inference)',
    'admin.ingestResult.parseFailed': 'result_json parse failed or empty',
    'admin.ingestResult.componentCounts': 'Component counts',
    'admin.ingestResult.fullJsonSummary': 'Full IngestPackage JSON ({kb} KB)',
    'admin.feedback.userNoteLabel': 'User note: ',
    'admin.feedback.viewAndUa': 'View: {view} · UA: {ua}',
    'admin.feedback.itemPreviewLabel': 'Item content snippet:',
    'admin.events.filterAllTypes': 'All types ({count})',
    // ── Operator dashboard (19BM-D · /__operator DEV-only tool page) ────
    'operator.pageTitle': 'Operator dashboard · Feedback aggregation',
    'operator.pageSubtitle': 'DEV-only · cross-course itemFeedback aggregation · for triaging prompt regressions / distractor failures / render bugs',
    'operator.backToHome': '← Back to home',
    'operator.tab.feedback': 'Feedback ({count})',
    'operator.tab.events': 'Events ({count})',
    'operator.stat.totalFlags': 'Total flags',
    'operator.stat.totalRatings': 'Total ratings',
    'operator.stat.avgRating': 'Avg rating (1–5)',
    'operator.stat.totalFeedback': 'Total feedback entries',
    'operator.byCourse.title': 'By course',
    'operator.byCourse.empty': 'No feedback entries yet. Flag some AI content to populate this page.',
    'operator.byCourse.colCourse': 'Course',
    'operator.byCourse.colFlag': 'flag',
    'operator.byCourse.colRatingCount': 'Ratings',
    'operator.byCourse.colRatingAvg': 'Avg rating',
    'operator.items.title': 'Item-level feedback (sorted by severity)',
    'operator.items.empty': 'No flags / ratings.',
    'operator.items.colCourse': 'Course',
    'operator.items.colType': 'Type',
    'operator.items.colItemField': 'Item id · field',
    'operator.items.colFlag': 'flag',
    'operator.items.colRating': 'Rating',
    'operator.items.colUpdatedAt': 'Updated at',
    'operator.items.colExpand': 'Expand',
    'operator.items.expand': 'View',
    'operator.items.collapse': 'Hide',
    'operator.items.noteLabel': 'User note: ',
    'operator.items.itemNotFound': 'No matching AI item found — may have been deleted or key resolution failed.',
    'operator.events.filterType': 'Type',
    'operator.events.filterAll': 'All ({count})',
    'operator.events.actionRefresh': 'Refresh',
    'operator.events.actionClear': 'Clear',
    'operator.events.empty': 'No events — appears after triggering actions (flag / edit / trigger error).',
    'operator.events.payloadLabel': 'payload',
    'operator.events.clearConfirm': 'Clear all event records? This cannot be undone.',
    'operator.events.clearConfirmAction': 'Clear',
    // ── Eval annotation page (19BM-D · /admin/eval quality annotation) ──
    'eval.title': 'Cram & Toss · Quality annotation (v{version})',
    'eval.header.submitted': ' · {count} submitted',
    'eval.header.alreadyAnnotated': 'Already annotated',
    'eval.error.scoresIncomplete': 'Please score all 4 dimensions (0-3) before submitting',
    'eval.error.saveFailed': 'Save failed: {message}',
    'eval.notice.needKey': 'Append <code>?key=&lt;ADMIN_KEY&gt;</code> to the URL.',
    'eval.notice.needKeyPrefix': 'Append ',
    'eval.notice.needKeyCode': '?key=<ADMIN_KEY>',
    'eval.notice.needKeySuffix': ' to the URL.',
    'eval.notice.needPoolPrefix': 'Provide ',
    'eval.notice.needPoolCode': '?pool=<candidate-json-url>',
    'eval.notice.needPoolSuffix': ' in the URL, e.g.:',
    'eval.notice.needPoolExample': '?key=K&pool=/docs/pools/sample-candidates.json&batch=exam-day2&seed=A&n=10',
    'eval.notice.poolLoadFailed': 'Candidate pool failed to load: {error}',
    'eval.notice.loading': 'Loading candidate pool…',
    'eval.notice.poolEmpty': 'Candidate pool is empty (pool URL returned 0 items). Check that the URL and the JSON top-level dimensions align.',
    'eval.notice.noMore': 'No more items. {count} annotations completed.',
    'eval.preview.missing': '(No preview · check candidate JSON integrity)',
    'eval.button.prev': '← Previous',
    'eval.button.submitNext': 'Submit & next',
    'eval.button.skip': 'Skip →',
    'eval.button.exportJson': 'Export JSON',
    'eval.button.exportCsv': 'Export CSV',
    'eval.button.import': 'Import',
    'eval.progress.summary': 'Progress ({done} / {total}) · agreement: {agreement}',
    'eval.form.flagsLegend': 'flags · optional',
    'eval.form.commentLegend': 'Comment · optional',
    'eval.form.commentPlaceholder': 'Write down the key observations driving your score…',
    'eval.toast.importDone': 'Import done: {written} / {total} saved to IDB',
    // ── 19BM-D Phase 5a: admin/eval/operator gaps ──────────────────────────
    'admin.error.httpStatus': 'HTTP {status}',
    'admin.action.downloadCsv': '↓ CSV',
    'admin.action.viewJson': 'JSON',
    'admin.ingestResult.runIdLabel': 'runId:',
    'admin.ingestResult.lintReport': 'Lint report',
    'admin.ingestResult.routingDecisions': 'Routing decisions (P2-1)',
    'admin.feedback.payloadJsonLabel': 'payload JSON',
    'admin.feedback.itemIdLabel': 'item:',
    'eval.header.progress': ' · {done} / {total}',
    'eval.flagReasonLabel': 'flag:',
    'operator.locked.title': 'Local operator dashboard · locked',
    'operator.locked.body1': 'This is a DEV-only page, hidden in prod by default. To unlock, visit:',
    'operator.locked.body2Prefix': 'Once unlocked this device stays visible (writes localStorage). For a ',
    'operator.locked.body2Strong': 'cross-user',
    'operator.locked.body2Suffix': ' dashboard (friends\' flags / errors / spend), go to <code>/admin?key=ADMIN_KEY</code> — that one hits D1 server-side and sees everyone\'s data.',
    // ── 19BM-D Phase 6a · Tier 1 reusable components ───────────────────────
    'common.edit': 'Edit',
    // FlagButton
    'flag.ariaLabel': 'Flag or rate',
    'flag.titleActive': 'Flagged / rated',
    'flag.titleIdle': 'Flag or rate',
    'flag.categoryWrong': 'This content is wrong / inaccurate',
    'flag.ratingLabel': 'Quality rating',
    'flag.starAria': '{count} star',
    'flag.notePlaceholder': 'Note (optional) — what\'s wrong / how to improve',
    'flag.repairTitle': 'Let AI generate a fix based on your feedback',
    'flag.repairAction': 'AI repair',
    // RepairDialog
    'repair.needDetail': 'Please describe what\'s wrong so AI can target the fix',
    'repair.budgetBlockedItem': 'This item used {used} / cap {cap}, please edit manually',
    'repair.budgetBlockedCourse': 'This course used {used} / cap {cap}, please edit manually',
    'repair.applied': 'Adopted AI repair version',
    'repair.keptOriginal': 'Kept original version',
    'repair.ariaLabel': 'AI repair',
    'repair.title': 'AI repair',
    'repair.itemBudget': 'This item used <code>{used}</code> / cap {cap}',
    'repair.courseBudget': 'This course <code>{used}</code> / {cap}',
    'repair.hint': 'Tell AI what\'s wrong with this content — the more specific, the better. AI keeps the item ID + stem, only fixing the problematic part.',
    'repair.placeholder': 'e.g. Option B is too obviously wrong (mentions Turing directly while others don\'t)&#10;e.g. Explanation too short, doesn\'t say why Case 2 applies&#10;e.g. Factual error — it\'s 1998 not 1997',
    'repair.submit': 'Let AI repair',
    'repair.loading': 'AI repairing… (~3-8 sec)',
    'repair.llmFailedPrefix': 'LLM call failed: ',
    'repair.schemaWarn': 'AI output failed schema validation (you can still compare, accepting not recommended)',
    'repair.currentVersion': 'Current version',
    'repair.repairedVersion': 'AI repaired version',
    'repair.keepOriginal': 'Keep original',
    'repair.retryPhrase': 'Retry with different phrasing',
    'repair.schemaRetryTitle': 'Repair failed schema validation, recommend retry',
    'repair.accept': 'Adopt AI version',
    // EditableText
    'editableText.revert': 'Revert to AI original',
    'editableText.revertConfirm': 'Revert to AI original? Your edits will be lost.',
    'editableText.editedBadge': 'Edited',
    'editableText.statusPending': 'Editing…',
    'editableText.statusSaving': 'Saving…',
    'editableText.statusSaved': 'Saved',
    'editableText.statusError': 'Save failed',
    // ChapterRegenButton
    'chapterRegen.disabledTitle': 'No regenerable modules enabled for this course',
    'chapterRegen.title': 'Regenerate this chapter',
    'chapterRegen.ariaLabel': 'Regenerate this chapter',
    'chapterRegen.modeGroup': 'Regeneration mode',
    'chapterRegen.loading': 'Regenerating',
    'chapterRegen.hintPlaceholder': 'Requirements for the generated content…',
    // course-dashboard
    'dashboard.flaggedLabel': 'Flagged in this course',
    // ── 19BM-D Phase 6b · Tier 2 reusable components ───────────────────────
    // CreateCourseForm
    'createCourse.fileTooLarge': 'Some files exceed 50 MB limit and were skipped',
    'createCourse.totalTooLarge': 'Total file size cannot exceed 200 MB',
    'createCourse.nameLabel': 'Course name',
    'createCourse.namePlaceholder': 'e.g. International Business',
    'createCourse.dateLabel': 'Exam date',
    'createCourse.dateTbd': 'Date TBD',
    'createCourse.codeLabel': 'Course code',
    'createCourse.codePlaceholder': 'Optional, e.g. IIMT2641',
    'createCourse.optional': 'Optional',
    'createCourse.disciplineLabel': 'Subject area',
    'createCourse.disciplineTemplates': 'Common subject quick-picks',
    'createCourse.customDisciplinePlaceholder': 'Exact subject, e.g. Law / Psychology / Organic Chemistry',
    'createCourse.customDisciplineHint': 'Specifying the exact subject lets AI match terminology and exam style more precisely (optional)',
    'createCourse.examTypeLabel': 'Exam type',
    'createCourse.examTypePlaceholder': 'Leave blank for generic style',
    'createCourse.examTypeHint': 'Picking an exam type lets AI tune terminology precision and answer structure for that scenario (optional · some subjects only)',
    'createCourse.languageLabel': 'Content language',
    'createCourse.uploadLabel': 'Upload source materials',
    'createCourse.dropzone': 'Drag PDF / PPTX / DOCX here, or click to browse',
    'createCourse.uploadHint': 'Supports PDF, PPTX, DOCX, MD, TXT · ≤ 50 MB per file · ≤ 200 MB total',
    'createCourse.aiHelp': 'AI will generate questions, notes, and flashcards based on your chosen subject and language, combined with the source material. File type labels above help AI understand each source\'s purpose.',
    'createCourse.creating': 'Creating…',
    'createCourse.submit': 'Create course & start generation',
    // ErrorBoundary
    'errorBoundary.inlinePrefix': 'This section failed to render: ',
    'errorBoundary.pageBody': 'This page hit a problem while rendering. Logged to the operator dashboard · you can refresh or go home to continue.',
    'errorBoundary.retryPage': 'Retry this page',
    'errorBoundary.refreshApp': 'Refresh entire app',
    'errorBoundary.home': 'Go home',
    // RegenConfirmPanel
    'regenConfirm.apply': 'Confirm Changes',
    'regenConfirm.replaceSummary': 'Replace {existing} → {items} items{chapterScope}',
    'regenConfirm.addSummary': 'Add {items} items{chapterScope}',
    'regenConfirm.selected': 'selected',
    'regenConfirm.applyN': 'Apply {count} items',
    'regenConfirm.discardAll': 'Discard All',
    // RegenPreview
    'regenPreview.confirmDelete': 'Confirm Delete',
    'regenPreview.confirmReplace': 'Confirm Replace',
    'regenPreview.confirmAdd': 'Confirm Add',
    'regenPreview.badgeQuick': '⚡ Quick',
    'regenPreview.badgeDeep': 'Async',
    'regenPreview.accept': 'Accept',
    'regenPreview.acceptN': 'Accept ({count})',
    'regenPreview.discard': 'Discard',
    // LintSummary
    'lint.title': 'Quality audit',
    'lint.toggleShow': 'Hide details',
    'lint.toggleHide': 'Show details ({count})',
    'lint.suggestion': 'Suggestion:',
    'lint.severityCount': '· {error} errors · {warn} warnings · {info} info',
    'lint.severityError': 'errors',
    'lint.severityWarn': 'warnings',
    'lint.severityInfo': 'info',
    'lint.verdictHighConf': 'Good quality',
    'lint.verdictLowConf': 'Needs review',
    'lint.verdictUnknown': 'Some issues',
    'lint.kind.mcqDistractorBalance': 'MCQ distractor balance',
    'lint.kind.difficultyDistribution': 'Difficulty distribution',
    'lint.kind.cognitiveCoverage': 'Bloom level coverage',
    'lint.kind.topicCoverage': 'Topic coverage',
    'lint.kind.citationTrace': 'Citation trace',
    'lint.kind.sourceRef': 'Structured source ref',
    'lint.kind.sharedConcepts': 'Shared concepts coverage',
    'lint.kind.optionParity': 'MCQ length parity',
    // MockPaperCreator
    'mockCreator.title': 'New Mock Paper',
    'mockCreator.nameLabel': 'Paper Title',
    'mockCreator.scopeLabel': 'Chapter Scope (empty = all)',
    'mockCreator.difficulty': 'Difficulty',
    'mockCreator.diffEasy': 'Easy',
    'mockCreator.diffMixed': 'Mixed',
    'mockCreator.diffHard': 'Hard',
    'mockCreator.itemCounts': 'Item Counts',
    'mockCreator.generate': 'Generate ({count} items)',
    // relativeTime (extracted from three duplicated implementations)
    'relativeTime.justNow': 'just now',
    'relativeTime.secondsAgo': '{count}s ago',
    'relativeTime.minutesAgo': '{count}m ago',
    'relativeTime.hoursAgo': '{count}h ago',
    'relativeTime.daysAgo': '{count}d ago',
    'relativeTime.older': '{date}',
    // ── 19BM-D Phase 6c · Tier 3 view-local ────────────────────────────────
    // OutlineReviewView
    'outlineReview.title': 'Confirm Course Structure',
    'outlineReview.subtitle': 'AI identified {chapters} chapters and {concepts} concepts from "{course}"',
    'outlineReview.note': 'Edit titles, adjust importance, or remove unwanted chapters',
    'outlineReview.quickConfirm': 'Looks good, start now',
    'outlineReview.quickConfirmHint': 'Skip editing, use AI-extracted structure as-is',
    'outlineReview.editConfirm': 'Confirm & Start Generating',
    'outlineReview.confirming': 'Starting…',
    'outlineReview.back': 'Go Back',
    'outlineReview.chapter': 'Chapter title',
    'outlineReview.importance': 'Importance',
    'outlineReview.concepts': 'Concepts',
    'outlineReview.conceptsCount': '{count} concepts',
    'outlineReview.noteLabel': 'Extra note (optional)',
    'outlineReview.notePlaceholder': 'Extra instructions for AI, e.g. "Focus on chapter 3"',
    'outlineReview.deleteLabel': 'Remove this chapter',
    'outlineReview.deleteConfirm': 'Delete chapter "{title}"?',
    'outlineReview.invalid': '⚠ Each chapter needs at least 1 concept',
    'outlineReview.feedback': 'Issue? Report here',
    'outlineReview.feedbackSent': 'Feedback received, thank you!',
    'outlineReview.advanced': 'Advanced editing',
    'outlineReview.advancedHint': 'Adjust cognitive levels, generation quotas, etc.',
    'outlineReview.bloom': 'Cognitive level focus',
    'outlineReview.bloomDesc': 'Select which cognitive abilities to emphasize',
    'outlineReview.quota': 'Generation quota',
    'outlineReview.quotaDesc': 'Customize items per chapter',
    'outlineReview.mustCover': 'Required coverage',
    'outlineReview.mustCoverDesc': 'Specify which question types must cover this concept',
    'outlineReview.addConcept': '+ Add concept',
    'outlineReview.addConceptPlaceholder': 'New concept name',
    'outlineReview.importance.overview': 'Overview',
    'outlineReview.importance.overviewDesc': 'Awareness level, rarely tested',
    'outlineReview.importance.understand': 'Understand',
    'outlineReview.importance.understandDesc': 'Standard requirement',
    'outlineReview.importance.keyTopic': 'Key topic',
    'outlineReview.importance.keyTopicDesc': 'Core focus, frequently tested',
    'outlineReview.step.upload': 'Upload',
    'outlineReview.step.review': 'Review',
    'outlineReview.step.generate': 'Generate',
    'outlineReview.step.study': 'Study',
    'outlineReview.feedbackTitle': 'Report an issue',
    'outlineReview.feedbackPlaceholder': 'Additional details (optional)',
    'outlineReview.feedbackSubmit': 'Submit',
    'outlineReview.feedbackMissingConcept': 'Missing concepts',
    'outlineReview.feedbackWrongStructure': 'Inaccurate structure',
    'outlineReview.feedbackWrongChapter': 'Wrong chapter divisions',
    'outlineReview.feedbackOther': 'Other issue',
    // outline-view
    'outlineView.chaptersCount': 'chapters',
    'outlineView.qualityAudit': 'Quality Audit',
    'outlineView.errorsCount': 'errors',
    'outlineView.warningsCount': 'warnings',
    'outlineView.clean': 'Clean',
    // outline-chapter-row
    'outlineChapter.aka': 'aka: ',
    'outlineChapter.generatedItems': 'Generated items',
    'outlineChapter.noItems': 'No items',
    'outlineChapter.quotaAdjust': 'Quota adjustments',
    'outlineChapter.ok': 'OK',
    // mindmap-view
    'mindmap.zoomOut': 'Zoom out (- key)',
    'mindmap.zoomIn': 'Zoom in (+ key)',
    'mindmap.fit': 'Fit screen (F key)',
    'mindmap.resetHint': '(0 key / double-click canvas)',
    'mindmap.helpBar': 'Click node to collapse / expand · Drag canvas to pan · Scroll / toolbar to zoom · Double-click or press 0 to reset',
    // mock-exam-phases
    'mockExam.subjectiveFree': 'Free response',
    'mockExam.subjectiveProof': 'Proof drill',
    'mockExam.subjectiveHint': 'During mock only the prompt is shown; after the exam, answer + self-assess in the corresponding module.',
    'mockExam.subjectiveReviewHint': 'For full answers + self-assessment, go to the corresponding module ({module}).',
    // course-gate-components
    'gate.stepParsing': 'Parsing uploaded materials…',
    'gate.stepStructure': 'Analyzing course structure…',
    'gate.stepOutline': 'Generating course outline…',
    // course-shell
    'nav.sidebarToggleClose': 'Close menu',
    'nav.sidebarToggleOpen': 'Open menu',
    // history-view
    'history.coursesCount': 'courses',
    'history.clean': 'Clean',
    // home
    'home.operatorLinkTitle': 'DEV-only · local IDB',
    'home.operatorLinkText': 'dev · operator (local)',
    'home.countdownDays': 'in {n}d',
    'home.countdownToday': 'exam today',
    'home.countdownPast': 'ended',
    'home.sealAlt': 'brand seal',
    // quiz-phases
    'quiz.editOptionsFlag': 'Edit options · flag',
    'quiz.wholeItemFlag': 'Whole item flag / rating · AI repair',
    'quiz.tfShortcuts': 'T/1 = True · F/2 = False · B = Bookmark',
    // wrong-answers-view
    'wrongAnswers.avgScore': ' · avg {avg}/3',
    // mermaid-block
    'mermaid.renderFailed': '⚠ mermaid render failed: ',
    // idb-health-watcher
    'idbHealth.unavailable': 'Local storage unavailable — current session progress will not be saved (private mode / browser storage disabled)',
    // ChapterCard
    'chapterCard.stageMcqs': 'MCQs',
    'chapterCard.stageFlashcards': 'Flashcards',
    // 19BO+ Line 2 B3.4 · evaluate dialog + verdict card
    'evaluate.title': 'AI Grading',
    'evaluate.ariaLabel': 'AI grading dialog',
    'evaluate.costHint': 'Costs ~3 points · returns a score with rubric feedback',
    'evaluate.confirm': 'Grade my answer',
    'evaluate.loading': 'Grading…',
    'evaluate.reviewHint': 'AI verdict · confirm to save',
    'evaluate.accept': 'Save verdict',
    'evaluate.cancel': 'Cancel',
    'evaluate.retry': 'Retry',
    'evaluate.rescore': 'Re-grade',
    'evaluate.scoreLabel': 'Score',
    'evaluate.rubricLabel': 'Rubric',
    'evaluate.feedbackLabel': 'Feedback',
    // 19BO+ Line 2 B4.3 · diagnose dialog + verdict card（对齐 evaluate 命名）
    'diagnose.title': 'AI Weak-Point Diagnosis',
    'diagnose.ariaLabel': 'AI diagnosis dialog',
    'diagnose.costHint': 'Costs ~3 points · analyses your wrong answers into prioritised weaknesses',
    'diagnose.confirm': 'Diagnose my weak points',
    'diagnose.loading': 'Diagnosing…',
    'diagnose.reviewHint': 'AI diagnosis · confirm to save',
    'diagnose.accept': 'Save diagnosis',
    'diagnose.cancel': 'Cancel',
    'diagnose.retry': 'Retry',
    'diagnose.weaknessesLabel': 'Weaknesses',
    'diagnose.severityHigh': 'High',
    'diagnose.severityMedium': 'Medium',
    'diagnose.severityLow': 'Low',
    'diagnose.summaryLabel': 'Overall summary',
    'diagnose.practiceLabel': 'Suggested practice',
    'diagnose.statsBasisLabel': 'Based on {total} wrong answers',
    // ── B5 桥5 · 后台自动诊断通知（use-auto-diagnose · 瞬时 toast）──────────────
    'diagnose.autoNotifTitle': 'Diagnosis ready for review',
    'diagnose.autoNotifMessage': 'A background diagnosis just finished — review the verdict on your dashboard.',
    'diagnose.autoNotifView': 'Review',
    // ── B5 桥5 · opt-in 开关（Settings · 成本提示）──────────────────────────────
    'diagnose.autoEnableLabel': 'Background auto-diagnosis',
    'diagnose.autoEnableHelp': 'When on, the app periodically runs AI weak-point diagnosis in the background while you study. Results wait for your review — nothing is applied without your confirmation.',
    'diagnose.autoIntervalLabel': 'Check every',
    'diagnose.autoInterval6h': '6 hours',
    'diagnose.autoInterval12h': '12 hours',
    'diagnose.autoInterval24h': '24 hours',
    'diagnose.autoCostHint': 'Each diagnosis costs ~3 points. Auto-diagnosis is skipped silently if your balance is too low.',
    // ── B5 桥5 · 待审 verdict 卡片（dashboard）───────────────────────────────────
    'diagnose.pendingTitle': 'New diagnosis awaiting your review',
    'diagnose.pendingHelp': 'This verdict was produced by background auto-diagnosis. Accept to make it your current diagnosis, or reject to discard.',
    'diagnose.pendingQueuedAgo': 'Produced {ago}',
    'diagnose.pendingAccept': 'Accept as current diagnosis',
    'diagnose.pendingReject': 'Discard',
    // ── B5 桥5 · quiz 完成态补练推荐块 ──────────────────────────────────────────
    'quiz.recommendPractice': 'Targeted practice for your weak points',
    'quiz.recommendPracticeHint': 'Based on your latest diagnosis, generate focused practice questions for the weak areas in this quiz.',
    'quiz.recommendGenerate': 'Generate practice questions',
    // ── B5.4 · 跨设备同步 UX（sync-status-chip + opt-in panel + hydration toast）──
    'sync.sectionTitle': 'Cross-device sync',
    'sync.toggleLabel': 'Sync learning progress across devices',
    'sync.toggleHint': 'When enabled, your mistakes / reviews / quiz records sync to the cloud and are available on other devices. When disabled, they are stored only on this device.',
    'sync.fieldsTitle': 'What syncs',
    'sync.fieldsCloudDesc': 'Synced to cloud: wrong answers, spaced-repetition state, quiz history, bookmarks, essay & free-response drafts.',
    'sync.fieldsLocalDesc': 'Stays on this device only: per-item edits, feedback, repairs (device-private).',
    'sync.statusIdle': 'Synced',
    'sync.statusPending': 'Pending · {count}',
    'sync.statusSaving': 'Syncing…',
    'sync.statusSaved': 'Synced',
    'sync.statusError': 'Sync failed',
    'sync.statusOffline': 'Offline',
    'sync.pendingCount': '{count} pending',
    'sync.lastSyncedAt': 'Last synced {time}',
    'sync.hydrated': 'Synced {count} records from cloud',
};
//# sourceMappingURL=en.js.map